module.exports = __webpack_public_path__ + "img/team.c6d5189c.svg";